import { render } from "./MinesGame.vue?vue&type=template&id=6cd9be92&scoped=true"
import script from "./MinesGame.vue?vue&type=script&lang=js"
export * from "./MinesGame.vue?vue&type=script&lang=js"

import "./MinesGame.vue?vue&type=style&index=0&id=6cd9be92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd9be92"]])

export default __exports__